import { colors as themeColors } from '../utils/theme';
import React from "react";
import { TextField, Box } from "@mui/material";

const TextArea = ({
  label,
  name,
  value,
  onChange,
  disabled = false,
  placeholder = "Enter text here...",
  rows = 2, // Default rows, customizable
  required = false, // Added required prop
}) => {
  return (
    <Box sx={{ width: "100%" }}>
      <TextField
        id={name}
        name={name}
        label={label}
        required={required} // Pass required prop
        value={value || ""}
        onChange={onChange}
        disabled={disabled}
        multiline
        rows={rows}
        fullWidth
        variant="outlined"
        size="small"
        InputLabelProps={{
          sx: {
            "& .MuiFormLabel-asterisk": { color: "red" }, // Red asterisk styling
          },
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "6px",
            "&.Mui-focused fieldset": { borderColor: "blue" },
          },
          "& .Mui-disabled": { backgroundColor: themeColors.neutral.surfaceAlt },
        }}
      />
    </Box>
  );
};

export default TextArea;